import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axios/axios.js";

export const GenerateContents = createAsyncThunk(
  "generateContent/generateContents",  
  async (topic) => {
    const response = await axios.post("/api/v1/ai/generate-content", { topic });
    return response.data; 
  }
);

const generateContentSlice = createSlice({
  name: "GenerateContent",
  initialState: {
    content: "", 
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GenerateContents.pending, (state) => {
        state.loading = true;
      })
      .addCase(GenerateContents.fulfilled, (state, action) => {
        state.loading = false;

        if (action.payload && action.payload.data && action.payload.data.content) {
          state.content = action.payload.data.content;
        } else {
         
          state.content = ""; 
        }
      })
      .addCase(GenerateContents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default generateContentSlice.reducer;
